import React from "react";

const LtcWhitepaperPage = () => {
  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
      }}
    >
      <iframe
        title="LTC Whitepaper"
        loading="lazy"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
        src="/ltc.pdf"
      />
    </div>
  );
};

export default LtcWhitepaperPage;
